import type { Guide } from '../types';

/**
 * S-26.10-01 — „Obsadza tylko Team Leader i administratorzy” (decyzja z 20.10.2026, makieta back office v2,
 * BR-FTL-01). Do 26.10.2026 działało bez przełącznika — przy wydaniu schowane za przełącznikiem, bo na produkcji
 * „Użytkownik” obsadza. Ten sam element co przewodnik „Obsadź u planisty wyszarzony” (S-20.10-03), oglądany
 * z konta „Użytkownik” (scenariusz e2e 31 sprawdza wersję jak na produkcji).
 */
export const guide: Guide = {
  flagKey: 'assignTeamLeaderOnly',
  title: 'Obsadza tylko Team Leader i administratorzy',
  whatItDoes:
    'Konto z rolą „Użytkownik” nie obsadza już zleceń pojazdem — obsadzają Team Leader (planista główny) i administratorzy. „Użytkownik” dalej dodaje warianty, pracuje w Trade i przyjmuje zlecenia, ale „Obsadź”, „Obsadź…” w wierszu banku i „Zmień pojazd” są dla niego niedostępne, a próba kończy się odmową. Razem z obsadzaniem znika mu alert o przeplanowaniu, jeśli alert widzi tylko planista główny. Bez tej zmiany „Użytkownik” obsadza tak jak dotąd.',
  audience: ['Użytkownik', 'Team Leader', 'administrator'],
  presentationItems: ['S-26.10-01'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie do obsadzenia z wariantami',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'FTL' },
      },
      target: 'assign-team-leader-only',
      title: '„Obsadź” nieaktywny dla konta „Użytkownik”',
      description:
        'Na karcie zlecenia „Użytkownik” widzi „Obsadź” nieaktywny z podpowiedzią, że obsadza Team Leader. Swój wybór pokazuje wariantem, a decyzję podejmuje Team Leader albo administrator.',
      action: 'Jako „Użytkownik” otwórz zlecenie z wariantami i najedź na „Obsadź”.',
      recorder: { account: 'sales', demo: { kind: 'order', number: 'DEMO/2026/10/V01' } },
    },
  ],
};
